import { IHooksUseRequestEditUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestEditUserParams;
type TResponseData = void;

export const useRequestEditUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'edit'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.users.edit, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userEdited', data })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base),
          invalidate(routes.api.reports.base)
        ])
    )
  });

  const triggerEditUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingEditUser: isPending,
    triggerEditUser,
    error
  });

};  
